export enum TypesEventsEnum {
    JURIDICO = "Jurídico",
    CONSULTOR = "Consultor",
    CONTABIL = "Contábil",
    PARCEIRO = "Parceiro",
  }
  
  export enum TypesEventsIdEnum {
    "Jurídico" = "1",
    "Consultor" = "2",
    "Contábil" = "3",
    "Parceiro" = "4",
  }
  
export enum LimitQuestionEventsEnum {
    ONE = "1",
    TWO = "2",
    THREE = "3",
    FOUR = "4",
    FIVE = "5",
    SIX = "6",
    SEVEN = "7",
    EIGHT = "8",
    NINE = "9",
}

export enum LimitQuestionEventsIdEnum  {
    ONE = "1",
    TWO = "2",
    THREE = "3",
    FOUR = "4",
    FIVE = "5",
    SIX = "6",
    SEVEN = "7",
    EIGHT = "8",
    NINE = "9",
}